import { isClient as r } from "./index40.mjs";
const a = "brand_data", o = () => {
  if (!r()) return;
  const t = localStorage.getItem(a);
  if (t)
    try {
      return JSON.parse(t);
    } catch {
      return;
    }
};
export {
  a as LOCAL_STORAGE_BRAND_DATA_ID,
  o as getBrandFromLocalStorage
};
